import { useRecoilValue } from 'recoil'
import passportSchemasAtom from '@/pages/MDM/atoms/passportSchemas.atom.ts'

const usePassportSchemas = () => {
  const state = useRecoilValue(passportSchemasAtom)

  return state.items
}

export default usePassportSchemas
